const activityLog = {
  title: "سجل النشاط",
  searchPlaceholder: "ابحث باسم المنفّذ",
  // Super Admin Full Logs — the API searches actor and company names.
  adminSearchPlaceholder: "ابحث بالمنفّذ أو الشركة",
  exportAll: "تصدير الكل",
  filters: {
    module: "القسم",
    company: "الشركة",
    dateRange: "الفترة الزمنية",
  },
  columns: {
    time: "الوقت",
    actor: "بواسطة",
    company: "الشركة",
    action: "الإجراء",
    module: "القسم",
  },
  showingRange: "عرض {from}-{to} من {total} إدخال",
  // لا توجد إدخالات أصلًا (بدون بحث أو فلاتر).
  noActivity: {
    title: "لا يوجد نشاط بعد",
    description:
      "ستظهر هنا الإجراءات التي تتم على الشركات والفعاليات والطلبات فور حدوثها.",
  },
  empty: {
    title: "لا يوجد نشاط مطابق",
    description: "لا يوجد نشاط يطابق البحث أو الفلاتر.",
    clear: "مسح الفلاتر",
  },
  exportModal: {
    title: "تصدير سجل النشاط",
    description: "اختر الحقول التي تريد تضمينها في الملف. يجب اختيار حقل واحد على الأقل.",
    selectAll: "تحديد كل الحقول",
    confirm: "تأكيد التصدير",
  },
  exportFields: {
    time: "الوقت",
    actorName: "اسم المنفّذ",
    actorRole: "دور المنفّذ",
    company: "الشركة",
    action: "الإجراء",
    module: "القسم",
  },
  exportFileName: "activity-log",
  // شاشة بوابة الشركة — ما يختلف عن شاشة الأدمن فقط.
  company: {
    filters: {
      role: "الدور",
      companyOwner: "مالك الشركة",
    },
    noActivityDescription: "ستظهر هنا الإجراءات التي تتم في هذه الشركة فور حدوثها.",
  },
};

export default activityLog;
